/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { BaseComponent } from '../../../../../core/components';
import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ValidationService } from '../../../../../core/services';
import { nameValidation } from '../../../../../core/directives';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-add-organisation',
    templateUrl: './add-organisation.component.html',
    styleUrls: ['./add-organisation.component.scss'],
})

export class AddOrganisationComponent extends BaseComponent {
    /**
     * Emit complete to parent component
     */
    @Output() public eventEmitter: EventEmitter<any> = new EventEmitter();

    /**
     * New organisation form group.
     */
    public organisationForm: FormGroup;

    /**
     * To store the file information.
     */
    public file: File;

    constructor(
        private formBuilder: FormBuilder,
    ) {
        super();

        this.setupForm();
        this.setupFormSubscribers();
    }

    /**
     * Read the file & check the extension type to ensure it is correct.
     * TODO waiting for a place to store the image
     * @param event
     */
    public onFileChange(event: any): void {
        this.organisationForm.get('image').setValue(event);
    }

    /**
     * Set up the new load balancer form.
     * @private
     */
    private setupForm(): void {
        this.organisationForm = this.formBuilder.group({
            image: [null],
            name: [null, [Validators.required, Validators.minLength(3), nameValidation]],
            phoneNumber: [null, ValidationService.phoneNumberValidator],
            countryCode: [null]
        });
    }

    /**
     * Set up the new load balancer form.
     * @private
     */
    private setupFormSubscribers(): void {
        this.organisationForm.valueChanges
            .pipe(takeUntil(this.destroyed$))
            .subscribe({
                next: (formValues: any): void => {
                    this.eventEmitter.next(formValues);
                }
            });

        const phoneNumberField = this.organisationForm.get('phoneNumber');
        phoneNumberField.valueChanges
            .pipe(takeUntil(this.destroyed$))
            .subscribe({
                next: (phoneNumber: string): void => {
                    if (phoneNumber?.length) {
                        phoneNumberField.markAsTouched();
                    }
                }
            });
    }
}

